export default function ResellersSection() {
  return (
    <section id="revendedores" className="bg-background-50 py-16 md:py-24">
      <div className="w-full px-4 md:px-8 lg:px-16">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-12">
            <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-5">
              <i className="ri-hand-coin-line text-sm w-4 h-4 flex items-center justify-center" />
              Oportunidad de Negocio
            </div>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
              Programa de <span className="text-accent-500">Revendedores</span>
            </h2>
            <p className="text-foreground-500 text-sm md:text-base max-w-2xl mx-auto">
              Producto terminado puesto en Venezuela. Usted compra, revende y gana. Sin complicaciones logísticas, sin inversión en formulación.
            </p>
          </div>

          {/* Price Highlight */}
          <div className="text-center mb-12">
            <div className="inline-block bg-accent-100/50 border border-accent-200/60 rounded-lg px-8 py-5">
              <p className="text-foreground-500 text-xs md:text-sm mb-1">Precio de Revendedor</p>
              <div className="font-heading text-4xl md:text-5xl font-bold text-foreground-950">
                $950<span className="text-accent-500 text-lg md:text-xl font-normal ml-1">/ Tambor</span>
              </div>
              <p className="text-foreground-500 text-xs mt-2">Importación directa desde China a Venezuela • Listo para revender</p>
            </div>
          </div>

          {/* Profit Cards */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6 mb-12">
            <div className="bg-background-100 rounded-lg p-6 border border-background-200/60">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4">
                <i className="ri-shopping-cart-2-line text-lg" />
              </div>
              <p className="text-foreground-500 text-xs font-medium mb-1">Usted Compra</p>
              <p className="text-foreground-950 font-heading text-xl font-bold mb-2">Desde $950</p>
              <p className="text-foreground-500 text-xs leading-relaxed">
                Precio fijo por tambor de 55 galones. Sin costos ocultos. Producto importado desde China, terminado y certificado, listo para entregar a su cliente final.
              </p>
            </div>

            <div className="bg-background-100 rounded-lg p-6 border border-accent-200/60 relative">
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-accent-500 text-background-50 text-xs font-bold px-3 py-1 rounded-full whitespace-nowrap">
                Mayor Rentabilidad
              </div>
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-4 mt-1">
                <i className="ri-money-dollar-circle-line text-lg" />
              </div>
              <p className="text-foreground-500 text-xs font-medium mb-1">Usted Revende</p>
              <p className="text-foreground-950 font-heading text-xl font-bold mb-2">$1,100 – $1,350</p>
              <p className="text-foreground-500 text-xs leading-relaxed">
                Precio de mercado comprobado para demulsificantes de esta calidad. Margen estimado de ganancia por tambor en el mercado venezolano actual.
              </p>
            </div>

            <div className="bg-background-100 rounded-lg p-6 border border-background-200/60">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-4">
                <i className="ri-line-chart-line text-lg" />
              </div>
              <p className="text-foreground-500 text-xs font-medium mb-1">Usted Gana</p>
              <p className="text-foreground-950 font-heading text-xl font-bold mb-2">$150 – $400</p>
              <p className="text-foreground-500 text-xs leading-relaxed">
                Por cada tambor. Con 20 tambores al mes, sus ganancias mensuales pueden superar los <strong className="text-primary-600">$8,000 USD</strong> líquidos.
              </p>
            </div>
          </div>

          {/* PDVSA Highlight */}
          <div className="bg-primary-100/50 border border-primary-200/60 rounded-lg p-5 md:p-7 mb-12">
            <div className="flex flex-col md:flex-row items-center gap-5 text-center md:text-left">
              <div className="w-14 h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 flex-shrink-0">
                <i className="ri-government-line text-2xl" />
              </div>
              <div className="flex-1">
                <p className="text-primary-700 text-xs font-medium uppercase tracking-wide mb-1">Máxima Rentabilidad</p>
                <h4 className="text-foreground-950 font-heading text-lg md:text-xl font-bold mb-2">
                  Para Empresas con Contrato en <span className="text-primary-600">PDVSA</span>
                </h4>
                <p className="text-foreground-600 text-sm leading-relaxed">
                  El tambor de demulsificante aprobado y certificado se vende a un precio de mercado de{' '}
                  <strong className="text-primary-600 text-base">$2,500 USD</strong>. Con un costo de solo $950,
                  su ganancia neta por tambor asciende a{' '}
                  <strong className="text-primary-600 text-base">$1,550 USD</strong>.
                  La aprobación en laboratorios PDVSA es su llave de entrada al cliente mejor pagador de Venezuela.
                </p>
              </div>
              <div className="bg-primary-100/70 rounded-lg px-6 py-4 text-center flex-shrink-0">
                <p className="text-foreground-500 text-xs mb-1">Ganancia por Tambor</p>
                <p className="text-primary-600 font-heading text-2xl md:text-3xl font-bold">$1,550</p>
                <p className="text-foreground-500 text-xs mt-1">USD</p>
              </div>
            </div>
          </div>

          {/* Profit Table */}
          <div className="bg-background-100 rounded-lg p-6 md:p-8 border border-background-200/60 mb-12 overflow-x-auto">
            <h4 className="text-foreground-950 font-heading text-base font-semibold mb-5 text-center">Proyección de Ganancias Mensuales</h4>
            <table className="w-full text-left min-w-[540px]">
              <thead>
                <tr className="border-b border-background-200/60">
                  <th className="text-foreground-500 text-xs font-medium py-3 pr-4">Tambores / Mes</th>
                  <th className="text-foreground-500 text-xs font-medium py-3 pr-4">Inversión</th>
                  <th className="text-foreground-500 text-xs font-medium py-3 pr-4">Venta Estimada</th>
                  <th className="text-foreground-500 text-xs font-medium py-3">Ganancia Neta</th>
                </tr>
              </thead>
              <tbody>
                <tr className="border-b border-background-200/30">
                  <td className="text-foreground-950 text-sm font-semibold py-3 pr-4">5</td>
                  <td className="text-foreground-600 text-sm py-3 pr-4">$4,750</td>
                  <td className="text-foreground-600 text-sm py-3 pr-4">$5,500 – $6,750</td>
                  <td className="text-accent-600 text-sm font-bold py-3">$750 – $2,000</td>
                </tr>
                <tr className="border-b border-background-200/30">
                  <td className="text-foreground-950 text-sm font-semibold py-3 pr-4">10</td>
                  <td className="text-foreground-600 text-sm py-3 pr-4">$9,500</td>
                  <td className="text-foreground-600 text-sm py-3 pr-4">$11,000 – $13,500</td>
                  <td className="text-accent-600 text-sm font-bold py-3">$1,500 – $4,000</td>
                </tr>
                <tr className="border-b border-background-200/30">
                  <td className="text-foreground-950 text-sm font-semibold py-3 pr-4">20</td>
                  <td className="text-foreground-600 text-sm py-3 pr-4">$19,000</td>
                  <td className="text-foreground-600 text-sm py-3 pr-4">$22,000 – $27,000</td>
                  <td className="text-accent-600 text-sm font-bold py-3">$3,000 – $8,000</td>
                </tr>
                <tr>
                  <td className="text-foreground-950 text-sm font-semibold py-3 pr-4">50</td>
                  <td className="text-foreground-600 text-sm py-3 pr-4">$47,500</td>
                  <td className="text-foreground-600 text-sm py-3 pr-4">$55,000 – $67,500</td>
                  <td className="text-accent-600 text-sm font-bold py-3">$7,500 – $20,000</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Support Cards */}
          <div className="text-center mb-10">
            <h4 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 mb-3">
              Respaldo Que <span className="text-primary-500">Garantiza Sus Ventas</span>
            </h4>
            <p className="text-foreground-500 text-sm max-w-xl mx-auto">
              No está solo. Cuenta con todo el respaldo técnico y comercial para cerrar cada negociación con confianza.
            </p>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5 mb-10">
            <div className="bg-background-100 rounded-lg p-5 border border-background-200/60 text-center">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 mx-auto mb-3">
                <i className="ri-flask-line text-xl" />
              </div>
              <h5 className="text-foreground-950 font-heading text-sm font-semibold mb-1">Asesores Químicos</h5>
              <p className="text-foreground-500 text-xs leading-relaxed">
                Ingenieros especializados acompañan cada venta con soporte técnico en sitio para sus clientes.
              </p>
            </div>
            <div className="bg-background-100 rounded-lg p-5 border border-background-200/60 text-center">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mx-auto mb-3">
                <i className="ri-team-line text-xl" />
              </div>
              <h5 className="text-foreground-950 font-heading text-sm font-semibold mb-1">Formuladores Expertos</h5>
              <p className="text-foreground-500 text-xs leading-relaxed">
                De la mano de Poly Alphas Chemicals C.A., formulaciones propietarias con resultados comprobados.
              </p>
            </div>
            <div className="bg-background-100 rounded-lg p-5 border border-background-200/60 text-center">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-secondary-100 text-secondary-600 mx-auto mb-3">
                <i className="ri-medal-line text-xl" />
              </div>
              <h5 className="text-foreground-950 font-heading text-sm font-semibold mb-1">Mejores Resultados</h5>
              <p className="text-foreground-500 text-xs leading-relaxed">
                El demulsificante con la mayor eficiencia de separación del mercado venezolano. Sus clientes lo notan desde el primer lote.
              </p>
            </div>
            <div className="bg-background-100 rounded-lg p-5 border border-background-200/60 text-center">
              <div className="w-12 h-12 flex items-center justify-center rounded-full bg-background-200 text-foreground-700 mx-auto mb-3">
                <i className="ri-truck-line text-xl" />
              </div>
              <h5 className="text-foreground-950 font-heading text-sm font-semibold mb-1">Logística Resuelta</h5>
              <p className="text-foreground-500 text-xs leading-relaxed">
                Producto puesto en Venezuela. Usted solo recibe, almacena y entrega. Sin dolores de cabeza con importaciones.
              </p>
            </div>
          </div>

          {/* CTA */}
          <div className="text-center">
            <a
              href="/"
              onClick={(e) => {
                e.preventDefault();
                window.location.href = '/#contact';
              }}
              className="inline-flex items-center gap-2 px-8 py-3.5 rounded-full bg-accent-500 text-background-50 font-semibold text-sm hover:bg-accent-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Quiero Ser Revendedor
              <i className="ri-arrow-right-line" />
            </a>
            <p className="text-foreground-500 text-xs mt-4">
              Escríbanos ahora y reciba asesoría personalizada para iniciar su negocio
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}